module.exports = __webpack_public_path__ + "img/status-up.63b0b41c.svg";